<template>
	<div>
		<variable-popup
			v-show="varPopup"
			:show="varPopup"
			:commands="commands"
			:editor="focusedEditor"
		></variable-popup>
		<command-popup v-show="cmdPop" :show="cmdPop" :commands="commands" :editor="focusedEditor"></command-popup>
		<menu-bar-global
			v-if="isEditable"
			class="editor__header"
			:editor="focusedEditor"
			:focused="focusedEditor !== undefined"
			@callback="
				val => {
					this.callbacke(val)
				}
			"
		/>
		<draggable
			:scroll-sensitivity="200"
			:force-fallback="true"
			:list="editorsArray"
			@change="triggerChange"
			:options="dragOptionsInside"
			:empty-insert-threshhold="200"
			handle=".handle"
		>
			<div :key="el.id" v-for="(el, index) in editorsArray">
				<menu-bar
					v-if="focusedEditor == el.editor && isEditable"
					class="editor__header"
					:editor="focusedEditor"
					:focused="focusedEditor !== undefined"
					@varpop="
						() => {
							varPopup = true
						}
					"
					@cmdpop="
						() => {
							cmdPop = true
						}
					"
				/>

				<div style="display: inline-flex; width: 100%">
					<div class="panel">
						<div style="width: 15px; margin: 4px">
							<el-checkbox v-model="el.checked"></el-checkbox>
						</div>
					</div>

					<div v-if="isEditable" class="md-button-icon" style="padding: 5px" @click="createNew(index, true)">
						<md-icon style="width: 5%" alt="Add block">add</md-icon>
					</div>
					<div
						class="md-button-icon"
						style="padding: 5px"
						v-if="editorsArray.length > 1 && isEditable"
						@click="deleteEditor(index)"
					>
						<md-icon style="width: 5%" alt="Add block">delete</md-icon>
					</div>
					<div
						v-if="isEditable"
						class="md-button-icon handle"
						style="padding: 5px; border-right: 1px solid gray"
					>
						<md-icon style="width: 5%" alt="Add block">open_with</md-icon>
					</div>
					<div @click="changeFocusedEditor(el.editor)" style="width: 85%; padding-left: 4px">
						<ProsemirrorRow
							:ref="el.id + '_ref'"
							@newBelow="
								() => {
									createNew(index)
								}
							"
							:editor="el.editor"
							@varpop="
								() => {
									varPopup = true
								}
							"
							@cmdpop="
								() => {
									cmdPop = true
								}
							"
							@delRow="
								() => {
									editorsArray.length > 1 ? BackspaceDelete(index) : null
								}
							"
						/>
					</div>
				</div>
			</div>
		</draggable>
	</div>
</template>
<script>
import draggable from "vuedraggable"
import ProsemirrorRow from "@/modules/prosemirror/component/row"
import { Editor } from "@tiptap/vue-2"
import StarterKit from "@tiptap/starter-kit"
import Highlight from "@tiptap/extension-highlight"
import Underline from "@tiptap/extension-underline"
import TaskList from "@tiptap/extension-task-list"
import TaskItem from "@tiptap/extension-task-item"
import History from "@tiptap/extension-history"
import Table from "@tiptap/extension-table"
import TableRow from "@tiptap/extension-table-row"
import TableHeader from "@tiptap/extension-table-header"
import { TextAlign } from "./text-align.ts"
import TableCell from "@tiptap/extension-table-cell"
import TextStyle from "@tiptap/extension-text-style"
import FontFamily from "@tiptap/extension-font-family"
import Text from "@tiptap/extension-text"

import { Color } from "./color.ts"
import Link from "@tiptap/extension-link"
import Variable from "@/modules/prosemirror/component/variable.ts"
import { fontSize } from "@/modules/prosemirror/component/font-size.ts"
import Enter from "./enter.ts"
import MenuBar from "./MenuBar.vue"
import VariablePopup from "@/modules/prosemirror/component/variable-popup_2"
import CommandPopup from "@/modules/prosemirror/component/command-popup"
import { OrderedList } from "@/modules/prosemirror/component/ordered-list.ts"
import { OrderedListLetters } from "@/modules/prosemirror/component/ordered-list-letters.ts"
import { uuid } from "@/modules/builder/utils/utils"
import Placeholder from "@tiptap/extension-placeholder"
import MenuBarGlobal from "@/modules/prosemirror/component/MenuBarGlobal"

export default {
	name: "editor",
	props: {
		value: {
			default: ""
		},
		isEditable: {}
	},
	computed: {
		dragOptionsInside() {
			return {
				group: {
					name: "just-another-things",
					sort: true,
					move: false,
					pull: false
				},
				sort: true,
				move: false,
				pull: false,
				disabled: false,
				animation: 200,
				max_nesting_chop_html: 150,
				nesting_chop_html_counter: 0
			}
		}
	},
	data() {
		return {
			editorsArray: [],
			returningVal: "",
			focusedEditor: undefined,
			varPopup: false,
			cmdPop: false,
			commands: undefined
		}
	},
	async mounted() {
		this.nesting_chop_html_counter = 0
		this.max_nesting_chop_html = 150
		if (this.value.docContent) {
			await this.chopHTML(this.value.docContent)
			// TODO in fase di sviluppo
		} else {
			//valore non presente, e quindi editor vuoto
			this.editorsArray.push(await this.newEditor())
		}
	},
	methods: {
		callbacke(e) {
			this.editorsArray.forEach(editor => {
				if (editor.checked) {
					editor.editor.commands.selectAll()
					e.fct(editor.editor)
					//una volta eseguita l'azione si deseleziona
					//se si lamentano, basta togliere la riga sotto
					//editor.checked=false
				}
			})
		},

		async chopHTML(data) {
			this.nesting_chop_html_counter += 1
			var probTag = [
				["<h1", "</h1>"],
				["<h2", "</h2>"],
				["<h3", "</h3>"],
				["<p", "</p>"],
				["<ul", "</ul>"],
				["<ol", "</ol>"],
				// ["<ol start=(\\\\.|(\"|'))\\d(\\\\.|(\"|'))", "</ol>"],
				["<pre", "</pre>"],
				["<blockquote", "</blockquote>"],
				["<table", "</table>"]
			]
			var specialType = [
				["<ul", "</ul>"],
				["<ol", "</ol>"]
				// ["<ol start=(\\\\.|(\"|'))\\d(\\\\.|(\"|'))", "</ol>"]
			]
			var splitOrigin = data.split(">")
			var type = probTag.find(e => new RegExp(e[0]).test(splitOrigin[0]))

			if (!type) {
				type = ["<p", "</p>"]
			}

			//testboi
			var testboi = specialType.find(e => new RegExp(e[0]).test(type[0]))
			if (testboi) {
				const doc = new DOMParser().parseFromString(data, "text/html")
				var lastIndx = data.lastIndexOf(testboi[1])
				var content = doc.children[0].children[1].children[0].outerHTML
				this.editorsArray.push(await this.newEditor(content))
				var newdata = undefined
				newdata = data.replace(content, "")
				// if (newdata) {
				if (newdata && this.nesting_chop_html_counter < this.max_nesting_chop_html) {
					await this.chopHTML(newdata)
				} else if (this.nesting_chop_html_counter >= this.max_nesting_chop_html) {
					this.$notification("error", this.$t("editor-error"), this.$t("editor-error-text"))
				}
			} else {
				var isFind = true
				if (!type) {
					isFind = false
					type = ["<p", "</p>"]
				}
				var split2 = data.split(type[1])
				//
				var content = split2[0] + type[1]
				this.editorsArray.push(await this.newEditor(content))
				var newdata = undefined
				if (isFind) {
					newdata = data.replace(content, "")
				} else {
					newdata = data.replace(content + "</p>", "")
				}
				// if (newdata) {
				if (newdata && this.nesting_chop_html_counter < this.max_nesting_chop_html) {
					await this.chopHTML(newdata)
				} else if (this.nesting_chop_html_counter >= this.max_nesting_chop_html) {
					this.$notification("error", this.$t("editor-error"), this.$t("editor-error-text"))
				}
			}
		},
		uuid,
		changeFocusedEditor(el) {
			this.focusedEditor = el
			el.isFocused = true
		},
		async newEditor(content = "") {
			var that = this
			var tmp = await new Editor({
				editable: this.isEditable,
				content: content,
				extensions: [
					StarterKit.configure({
						history: false,
						orderedList: false,
						codeBlock: false,
						paragraph: true
					}),
					Highlight,
					Underline,
					TaskList,
					TaskItem,
					History,
					//todo https://www.tiptap.dev/api/marks/link/
					Link,
					Placeholder.configure({
						emptyEditorClass: "is-editor-empty",
						placeholder: this.$t("placeholder-for-editor"),
						showOnlyWhenEditable: false,
						showOnlyCurrent: false
					}),
					Table.configure({
						resizable: true
					}),
					TableRow,
					OrderedList,
					OrderedListLetters,
					TableHeader,
					TextAlign.configure({
						types: ["heading", "paragraph"]
					}),
					TextStyle,
					Color,
					// Default TableCell
					// TableCell,
					// Custom TableCell with backgroundColor attribute
					TableCell,
					Variable,
					fontSize,
					FontFamily,

					Text,
					Enter
				],
				onUpdate({ editor }) {
					obj.content = editor.getHTML()
					that.triggerChange(obj.id)
				}
			})
			var tmpID = JSON.parse(JSON.stringify(uuid()))
			tmp.parent = this
			//            tmp.vue=this
			var obj = { id: tmpID, editor: tmp, content: content, option: true, checked: false }
			return obj
		},
		triggerChange(id) {
			//id inutile??
			//qua sembra di si
			this.$nextTick(() => {
				var tmp = this.editorsArray.reduce((old, newer) => {
					if (old) {
						if (old.content) {
							if (old.content && newer.content) {
								return old.content + newer.content
							}
						} else {
							if (newer.content) {
								return old + newer.content
							}
						}
						return old.content
					} else {
						return "<p></p>" + newer.content
					}
				})
				if (typeof tmp === "object") {
					tmp = tmp.content
				}
				if (tmp) {
					this.$emit("editVal", {
						docContent: tmp
					})
				} else {
				}
			})
		},
		async createNew(indx, fromButton = false) {
			var isUL = false
			var isOL = false
			var lastOLNum = 1
			//todo COSI NON VA BENE, è da modificare il comportamento del tasto enter, ma va studiato come fare l'override di tutto e non c'è doc
			var tmpEl = this.editorsArray[indx]
			var lastIndx = this.$refs[tmpEl.id + "_ref"][0].$el.childNodes[0].childNodes[0].childNodes.length - 1

			if (
				this.$refs[tmpEl.id + "_ref"][0].$el.childNodes[0].childNodes[0].childNodes[lastIndx].innerHTML ===
				'<br class="ProseMirror-trailingBreak">'
			) {
				this.$refs[tmpEl.id + "_ref"][0].$el.childNodes[0].childNodes[0].childNodes.item(lastIndx).remove()
			} else {
				//if ul
				if (
					(this.$refs[tmpEl.id + "_ref"][0].$el.childNodes[0].childNodes[0].childNodes[lastIndx].lastChild
						.innerHTML === "<p><br></p>" ||
						(this.$refs[tmpEl.id + "_ref"][0].$el.childNodes[0].childNodes[0].childNodes[lastIndx].lastChild
							.nodeName === "LI" &&
							this.$refs[tmpEl.id + "_ref"][0].$el.childNodes[0].childNodes[0].childNodes[lastIndx]
								.lastChild.innerHTML !== "<p><br></p>")) &&
					this.$refs[tmpEl.id + "_ref"][0].$el.childNodes[0].childNodes[0].childNodes[lastIndx].nodeName ===
						"UL"
				) {
					isUL = true
				} else {
					if (
						(this.$refs[tmpEl.id + "_ref"][0].$el.childNodes[0].childNodes[0].childNodes[lastIndx].lastChild
							.innerHTML === "<p><br></p>" ||
							(this.$refs[tmpEl.id + "_ref"][0].$el.childNodes[0].childNodes[0].childNodes[lastIndx]
								.lastChild.nodeName === "LI" &&
								this.$refs[tmpEl.id + "_ref"][0].$el.childNodes[0].childNodes[0].childNodes[lastIndx]
									.lastChild.innerHTML !== "<p><br></p>")) &&
						this.$refs[tmpEl.id + "_ref"][0].$el.childNodes[0].childNodes[0].childNodes[lastIndx]
							.nodeName === "OL"
					) {
						isOL = true
					}
				}
			}

			if ((!isOL && !isUL) || fromButton) {
				var tmp = await this.newEditor()
				this.editorsArray.splice(indx + 1, 0, tmp)
				//remove last blank row on enter
				this.$nextTick(() => {
					this.changeFocusedEditor(this.editorsArray[indx + 1].editor)
					this.triggerChange()
					this.focusedEditor.commands.focus()
					// if (isUL) {
					// 	this.editorsArray[indx + 1].editor.chain().focus().toggleBulletList().run()
					// } else if (isOL && lastOLNum !== 1) {
					// 	this.editorsArray[indx + 1].editor.chain().focus().toggleOrderedList({ num: lastOLNum }).run()
					// }
					// this.$refs[tmp.id+'_ref'][0].$el.childNodes[0].childNodes
				})
			}
			this.triggerChange()
		},
		async deleteEditor(id) {
			this.editorsArray.splice(id, 1)
			this.triggerChange()
			var editor
			if (id) {
				editor = this.editorsArray[id - 1]
			} else {
				editor = this.editorsArray[id + 1]
			}
			if (editor) {
				this.changeFocusedEditor(editor.editor)
			}
		},
		BackspaceDelete(index) {
			if (index) {
				this.editorsArray.splice(index, 1)
				var tmp = this.editorsArray[index - 1]
				this.changeFocusedEditor(this.editorsArray[index - 1].editor)
				this.triggerChange()
				this.focusedEditor.commands.focus("end")
			}
		}
	},
	components: {
		MenuBarGlobal,
		ProsemirrorRow,
		MenuBar,
		VariablePopup,
		CommandPopup,
		draggable
	}
}
</script>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
	transition: width 0.5s;
}

.fade-enter,
.fade-leave-to {
	width: 0;
}

.fade-enter-to,
.fade-leave {
	width: 25px;
}

.panel {
	position: relative;
	top: 0px;
	left: 0;
	border-radius: 10px;
	border: 1px solid #ccc;
	height: 30px;
}
.editor__header {
	display: flex;
	align-items: center;
	flex: 0 0 auto;
	flex-wrap: wrap;
	padding: 0.25rem;
	margin-bottom: 10px;
	border-bottom: 3px solid #0d0d0d;
}

.editor {
	display: flex;
	flex-direction: column;
	//max-height: 400px;
	color: #0d0d0d;
	background-color: white;
	//border: 3px solid #0D0D0D;
	border-radius: 0.75rem;

	&__header {
		display: flex;
		align-items: center;
		flex: 0 0 auto;
		flex-wrap: wrap;
		padding: 0.25rem;
		margin-bottom: 10px;
		border-bottom: 3px solid #0d0d0d;
	}

	&__content {
		padding: 0.25rem 0.1rem;
		flex: 1 1 auto;
		overflow-x: hidden;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	&__footer {
		display: flex;
		flex: 0 0 auto;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		white-space: nowrap;
		border-top: 3px solid #0d0d0d;
		font-size: 12px;
		font-weight: 600;
		color: #0d0d0d;
		white-space: nowrap;
		padding: 0.25rem 0.75rem;
	}

	/* Some information about the status */
	&__status {
		display: flex;
		align-items: center;
		border-radius: 5px;

		&::before {
			content: " ";
			flex: 0 0 auto;
			display: inline-block;
			width: 0.5rem;
			height: 0.5rem;
			background: rgba(#0d0d0d, 0.5);
			border-radius: 50%;
			margin-right: 0.5rem;
		}

		&--connecting::before {
			background: #616161;
		}

		&--connected::before {
			background: #b9f18d;
		}
	}

	&__name {
		button {
			background: none;
			border: none;
			font: inherit;
			font-size: 12px;
			font-weight: 600;
			color: #0d0d0d;
			border-radius: 0.4rem;
			padding: 0.25rem 0.5rem;

			&:hover {
				color: #fff;
				background-color: #0d0d0d;
			}
		}
	}
}

/* Placeholder (at the top) */
.ProseMirror p.is-editor-empty:first-child::before {
	content: attr(data-placeholder);
	float: left;
	color: #adb5bd;
	pointer-events: none;
	height: 0;
}

/* Placeholder (on every new line) */
/*.ProseMirror p.is-empty::before {
  content: attr(data-placeholder);
  float: left;
  color: #adb5bd;
  pointer-events: none;
  height: 0;
}*/
</style>
<style lang="scss">
@import "@/assets/scss/editor.scss";
</style>
